import {put, takeEvery} from "redux-saga/effects";
import {User} from "../../../Models/User";
import {fillItems} from "../../utils";
import {
    userCreateError,
    userCreateSuccess,
    userLoadError,
    userLoadSuccess,
    usersGetError,
    usersGetSuccess,
    userUpdateError,
    userUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* usersSagas() {
    yield takeEvery(TYPES.USERS_GET_REQUEST, usersGetRequest);
    yield takeEvery(TYPES.USER_LOAD_REQUEST, userLoadRequest);
    yield takeEvery(TYPES.USER_CREATE_REQUEST, userCreateRequest);
    yield takeEvery(TYPES.USER_UPDATE_REQUEST, userUpdateRequest);
}

function* usersGetRequest(action) {
    try {
        const response = yield User.index({
            ...action.payload,
        });

        yield put(
            usersGetSuccess({
                ...fillItems(response, User),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(usersGetError(error));
    }
}

function* userLoadRequest(action) {
    try {
        const response = yield User.find(action.payload);

        yield put(
            userLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(userLoadError(error));
    }
}

function* userCreateRequest(action) {
    try {
        const response = yield User.create();

        yield put(
            userCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(userCreateError(error));
    }
}

function* userUpdateRequest(action) {
    try {
        const response = yield User.update(action.payload.id, action.payload);

        yield put(
            userUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(userUpdateError(error));
    }
}
